import dynamic from 'next/dynamic';
const TablePrimary = dynamic(() => import('./TablePrimary'));
export default TablePrimary;
